

export class EnumSummary {

    private enumType: string;       //what is the type of the enum?
    private enumName: string;         //what is the name of the enum?
    private enumDescription: string;  //what does the enum do?

    constructor(enumType:string,
        enumName:string,
        enumDescription:string )
    {
        this.enumType = enumType;
        this.enumName = enumName;
        this.enumDescription = enumDescription;

    }

    public getModifierType(){
        return this.enumType;
    }

    public getEnumName(){
        return this.enumName;
    }

    public getEnumDescription(){
        return this.enumDescription;
    }



}